import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { AppPlatformService } from 'src/app/alliance-group/core/services/app-platform.service';
import { map } from 'rxjs';
import { AppRoutes } from '../app.model';

export const DesktopGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const appPlatformService = inject(AppPlatformService);

  return appPlatformService.isPlatformReady$.pipe(
    map(state => {
      console.log('DesktopGuard deviceService', state, appPlatformService.deviceService);
      // const isDesktop1 = appPlatformService.deviceService.deviceType === 'desktop';
      // const isDesktop = appPlatformService.deviceService.isDesktop();
      // const isTablet = appPlatformService.deviceService.isTablet();
      const isMobile = appPlatformService.deviceService.isMobile();

      if (isMobile) {
        router.navigate([AppRoutes.DeviceLanding]);
      }

      return !isMobile;
    }),
  );
};
